<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <action-bar [showSave]="true" [showDelete]="form?.value?.euId" (onSave)="clickSave(form?.value)" (onDelete)="clickDelete(form?.value?.euId)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" maxlength="10" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'user_entity_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="256" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 256</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'user_entity_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_parent' | translate }}</mat-label>
                <input matInput formControlName="parent" />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</div>
